import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { faqs } from "../data/landing";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-5 py-16 text-navy-900 sm:py-20" data-id="element-108" data-mp="1ceqf7rwsn5je">
      <div className="mx-auto max-w-3xl" data-id="element-109" data-mp="1ccdooqcyzmuq">
        <h2 className="text-center font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-110" data-mp="2a2icsmzrk8ri">Frequently Asked Questions</h2>
        <ul className="mt-10 divide-y divide-navy-900/10 rounded-3xl bg-white px-5 sm:px-7" data-id="element-111" data-mp="254gtc0yfe7fi">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} data-id="element-112" data-mp="1v3y56tztw4rs" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left text-base font-bold focus:outline-none focus-visible:text-gold-600" data-id="element-113" data-mp="1v4pvbpanpaao">
                  {f.q}
                  <PlusIcon className={`h-5 w-5 shrink-0 text-gold-600 transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-114" data-mp="1pls1e1uhffdd" />
                </button>
                <AnimatePresence initial={false} data-id="element-115" data-mp="1fqq94x4wtx6k">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-116" data-mp="11vxr9s1js4wt">
                      <p className="pb-5 text-[15px] leading-relaxed text-navy-700" data-id="element-117" data-mp="iy4mslb9zmxb">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
        <div className="mt-10" data-id="element-118" data-mp="2po80xqmjdn04">
          <CTAButton label="All Clear — Get My Access Now" data-id="element-119" data-mp="2kvwyag0evn3v" />
        </div>
      </div>
    </section>;
}